
import Button from '../../../components/base/Button';

export default function WellnessAcademySection() {
  const wellnessPrograms = [
    {
      title: "Mental Health Support",
      sessions: "Weekly",
      type: "Group Sessions",
      description: "Confidential support groups and counseling services for healthcare professionals.",
      icon: "ri-heart-3-line",
      features: ["Peer Support", "Professional Counseling", "Crisis Intervention", "Stress Management"]
    },
    {
      title: "Work-Life Balance",
      sessions: "Monthly",
      type: "Workshop Series",
      description: "Practical strategies for maintaining healthy boundaries and preventing burnout.",
      icon: "ri-scales-3-line",
      features: ["Time Management", "Boundary Setting", "Family Integration", "Career Planning"]
    },
    {
      title: "Physical Wellness",
      sessions: "Ongoing",
      type: "Fitness Programs",
      description: "Fitness challenges, ergonomic training, and health screenings for members.",
      icon: "ri-run-line",
      features: ["Fitness Challenges", "Health Screenings", "Ergonomic Training", "Nutrition Guidance"]
    },
    {
      title: "Professional Development",
      sessions: "Quarterly",
      type: "Leadership Training",
      description: "Leadership skills, communication training, and career advancement programs.",
      icon: "ri-award-line",
      features: ["Leadership Skills", "Communication", "Conflict Resolution", "Team Building"]
    }
  ];

  const testimonials = [
    {
      name: "Dr. Amanda Chen",
      role: "Clinical Pharmacist",
      location: "Toronto, ON",
      quote: "The Wellness Academy has been a game-changer for my mental health. The support groups provide a safe space to discuss the unique challenges we face as healthcare professionals."
    },
    {
      name: "Dr. Michael Thompson",
      role: "Veterinarian",
      location: "Calgary, AB",
      quote: "The work-life balance workshops helped me establish boundaries that have significantly improved my relationship with my family and my job satisfaction."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-heart-3-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Wellness Academy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Holistic wellness programs focusing on mental health, work-life balance, and professional development for healthcare providers.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {wellnessPrograms.map((program, index) => (
            <div key={index} className="bg-white rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <i className={`${program.icon} text-xl text-blue-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{program.title}</h3>
                  <div className="flex items-center text-sm text-gray-500">
                    <span>{program.sessions}</span>
                    <span className="mx-2">•</span>
                    <span>{program.type}</span>
                  </div>
                </div>
              </div>
              
              <p className="text-gray-600 mb-6">
                {program.description}
              </p>
              
              <div className="grid grid-cols-2 gap-3 mb-6">
                {program.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </div>
                ))}
              </div>
              
              <Button variant="outline" size="sm">
                Learn More
              </Button>
            </div>
          ))}
        </div>
        
        <div className="bg-white rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Member Testimonials
          </h3>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-user-line text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                    <div className="text-sm text-gray-500">{testimonial.location}</div>
                  </div>
                </div>
                <p className="text-gray-600 italic">
                  "{testimonial.quote}"
                </p>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Join thousands of healthcare professionals who have found support, balance, and growth through our Wellness Academy programs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg">
                Get Started Today
              </Button>
              <Button variant="outline" size="lg">
                Book Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
